module.exports = __webpack_public_path__ + "static/media/sim_background.c2208cc0.jpg";